import { render, staticRenderFns } from "./busbrand.vue?vue&type=template&id=4e80a41e&"
import script from "./busbrand.vue?vue&type=script&lang=js&"
export * from "./busbrand.vue?vue&type=script&lang=js&"
import style0 from "./busbrand.vue?vue&type=style&index=0&id=4e80a41e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports